import type { TaskResult } from "../types";

export async function gradeProject9(): Promise<TaskResult[]> {
  const results: TaskResult[] = [];

  // Tarea 1: Reemplazar "Choco" con "Chocolate" en todo el libro
  try {
    await Excel.run(async (context) => {
      const ws1 = context.workbook.worksheets.getItem("Costos");
      const ws2 = context.workbook.worksheets.getItem("Ganancias");

      const body1 = ws1.tables.getItem("CostosSabor").getDataBodyRange();
      body1.load("values");
      const body2 = ws2.tables.getItem("GananciasSabor").getDataBodyRange();
      body2.load("values");
      await context.sync();

      let hasChoco = false;
      const check = (values: unknown[][]) => {
        for (const row of values) {
          for (const cell of row) {
            const val = String(cell);
            const stripped = val.replace(/chocolate/gi, "");
            if (/choco/i.test(stripped)) {
              hasChoco = true;
            }
          }
        }
      };
      check(body1.values);
      check(body2.values);

      results.push({ taskId: 1, passed: !hasChoco });
    });
  } catch {
    results.push({ taskId: 1, passed: false });
  }

  // Tarea 2: Repetir filas de título y encabezados en páginas impresas (Costos)
  try {
    await Excel.run(async (context) => {
      const ws = context.workbook.worksheets.getItem("Costos");
      const titleRows = ws.pageLayout.getPrintTitleRows();
      titleRows.load(["rowIndex", "rowCount"]);
      await context.sync();

      // Must be exactly rows 1 through 3 (rowIndex 0 = row 1, rowCount 3)
      const passed = titleRows.rowIndex === 0 && titleRows.rowCount === 3;
      results.push({ taskId: 2, passed });
    });
  } catch {
    results.push({ taskId: 2, passed: false });
  }

  // Tarea 3: Formato Número en columnas B a E de Costos
  try {
    await Excel.run(async (context) => {
      const ws = context.workbook.worksheets.getItem("Costos");
      const sample = ws.getRange("B4:E4");
      sample.load("numberFormat");
      await context.sync();

      let passed = true;
      for (const fmt of sample.numberFormat[0]) {
        if (String(fmt) === "General") {
          passed = false;
          break;
        }
      }
      results.push({ taskId: 3, passed });
    });
  } catch {
    results.push({ taskId: 3, passed: false });
  }

  // Tarea 4: Gráfico con Sabores en eje horizontal, Gastos e Ingresos como series
  try {
    await Excel.run(async (context) => {
      const ws = context.workbook.worksheets.getItem("Ganancias");
      const charts = ws.charts;
      charts.load("items");
      await context.sync();

      let passed = false;
      if (charts.items.length > 0) {
        const chart = charts.items[0];
        const series = chart.series;
        series.load("items/name");
        await context.sync();

        if (series.items.length === 2) {
          const names = series.items.map((s) => s.name.toLowerCase());
          passed = names.includes("gastos") && names.includes("ingresos");
        }
      }
      results.push({ taskId: 4, passed });
    });
  } catch {
    results.push({ taskId: 4, passed: false });
  }

  // Tarea 5: Leyenda del gráfico en la parte de arriba
  try {
    await Excel.run(async (context) => {
      const ws = context.workbook.worksheets.getItem("Ganancias");
      const charts = ws.charts;
      charts.load("items");
      await context.sync();

      let passed = false;
      if (charts.items.length > 0) {
        const chart = charts.items[0];
        chart.legend.load("position");
        await context.sync();

        passed = String(chart.legend.position).toLowerCase() === "top";
      }
      results.push({ taskId: 5, passed });
    });
  } catch {
    results.push({ taskId: 5, passed: false });
  }

  return results;
}
